import React from "react";
import Container from "../atoms/Container";
import { Link } from "gatsby";
import styled from "styled-components";
import Logo from "../../assets/svg/full-logo-weft.inline.svg";

const Holder = styled.footer`
  display: grid;
  row-gap: 2rem;
  ${(props) => props.theme.fluidType(-1)}
  border-top: 1px solid #3ED3CB;
  margin-top: 2rem !important;

  @media (${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 2fr 1fr;
  }
`;

const SocialsHolder = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 2rem;
  align-content: start;
  padding-top: 0.8rem;
  ${(props) => props.theme.fluidType(-2)}
  p {
    margin: 0;
  }

  a {
    text-decoration: none;
    color: #3ed3cb;
  }
`;

const Acknowledgement = styled.p`
  margin: 1rem 1rem 0 0;
  ${(props) => props.theme.fluidType(-1)}
  max-width: 420px;
`;

const Address = styled.div`
  color: #707070;
  font-family: "Inter";

  p {
    line-height: 1.3;
    font-weight: normal;
  }
`;

const LogoHolder = styled.div`
  padding: 1rem 0;
  max-width: 90%;
`;

const TermsHolder = styled.div`
  color: #707070;
  p {
    line-height: 1.2;
    font-weight: normal;
  }

  @media (${(props) => props.theme.breakpoints.md}) {
    grid-column-start: 2;
    grid-row-start: 2;
    align-self: center;
  }
`;

function Footer() {
  return (
    <Container>
      <Holder className="Footer">
        <div>
          <SocialsHolder>
            <p>Email</p>
            <p>
              <a href="mailto:hello@weftstrategy.com">
                hello@weftstrategy.com
              </a>
            </p>
            <p>Insta</p>
            <p>
              <a
                href="https://www.instagram.com/weftstrategy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                @weftstrategy
              </a>
            </p>
            <p>LinkedIn</p>
            <p>
              <a
                href="https://www.linkedin.com/company/weftstrategy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                WeftStrategy
              </a>
            </p>
          </SocialsHolder>
          <Acknowledgement>
            We acknowledge the Gadigal, the traditional custodians of the
            Country on which we live and work.
          </Acknowledgement>
        </div>
        <Address>
          <p>
            <strong>WEFT STRATEGY PTY LIMITED</strong>
            <br />
          </p>
        </Address>
        <TermsHolder>
          <p>
            <Link to="/Terms">TERMS OF USE</Link>
            <br />
            <Link to="/Privacy">PRIVACY POLICY</Link>
            <br />
            COPYRIGHT © WEFT STRATEGY {new Date().getFullYear()}
            <br />
            ABN: 80 696 368 573
          </p>
        </TermsHolder>
        <LogoHolder>
          <Logo />
        </LogoHolder>
      </Holder>
    </Container>
  );
}

export default Footer;

